var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"loading":!_vm.office}},[(_vm.office)?_c('template',{slot:"header"},[_c('page-header',{attrs:{"title":("" + (_vm.office.name))}})],1):_vm._e(),_c('v-container',{attrs:{"fluid":""}},[_vm._v("WIP")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }